import { useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { SignUpForm7ways } from '@components/Block'

function MemoryLoss (props) {

	const [lgShow, setLgShow] = useState(false);

return (
	<>
	<div className="sevenWays__MemoryLoss pt-5">
		<Container>
			<Row>
				<Col lg={5} md={12} sm={12}>
				<p className="">Memory loss is a frightening thing. A lot of people think that if they're having memory problems, their memory is lost and gone for good.</p>
				<p className="">Thankfully the brain is like your muscles. Both can be toned up at any age. After reading this report, you'll feel empowered to make better choices and develop simple strategies to keep your brain fit for life.</p>
				<p className="">It's easier than you think!</p>
				<p className="">Click the “DOWNLOAD NOW” button to get the free report</p>
				<Button variant="default px-5 py-2 mt-4 text-left" onClick={() => setLgShow(true)}>DOWNLOAD NOW</Button>
				</Col>
			</Row>
		</Container>
		<SignUpForm7ways show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
	</div>
	<style jsx global>{`
		`}
	</style>
	<style jsx>{`
			.sevenWays__MemoryLoss{
				background: url(../images/7ways/bg-man-memory01.jpg)  no-repeat top center;
				padding: 50px 0px 90px;
				color: #FFF;
			}
			p{
				font-size:1rem;
			}
			`}
		</style>
	</>
);
}
export default MemoryLoss;